import React from 'react';

import Icon, { Props } from './icon';

export const EditIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7,4.9c0.1-0.1,0.3-0.1,0.4,0l1.9,1.9c0.1,0.1,0.1,0.3,0,0.4v0l-1.3,1.3l-2.3-2.3L16.7,4.9z M14.2,7.4
        l-9.3,9.3l0,0c-0.1,0.1-0.1,0.1-0.1,0.2v2.2h2.2c0.1,0,0.2,0,0.2-0.1l0,0l9.3-9.3L14.2,7.4z M18.4,3.7c-0.8-0.8-2-0.8-2.8,0
        L3.7,15.5l0,0c-0.4,0.4-0.6,0.9-0.6,1.4V20c0,0.5,0.4,0.8,0.8,0.8h3.1c0.5,0,1-0.2,1.4-0.6l0,0L20.3,8.5v0c0.8-0.8,0.8-2,0-2.8
        L18.4,3.7z"
      />
    </Icon>
  );
};

export default React.memo(EditIcon);
